import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class EntityOrderingTheRideForm extends AppForm {
  constructor() {
    super({
      orderingEntityName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),

      orderingEntityPostalCode: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      orderingEntityPostOffice: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      orderingEntityCity: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      orderingEntityStreet: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      orderingEntityHouseNumber: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(255)],
        nonNullable: true
      }),
      orderingEntityApartmentNumber: new FormControl('', Validators.maxLength(255))
    });
  }
}
